module.exports = __webpack_public_path__ + "img/92124892-54cc2e00-edcc-11ea-8994-f15925e53b1e-600x450.81adcd8e.jpg";